import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Iconify } from "app/components/Iconify";
import { ChangeEvent, useState } from "react";
import { FieldPath, FieldPathValue, FieldValues } from "react-hook-form";

import {
  BaseTextFieldElement,
  BaseTextFieldElementProps,
} from "./base/BaseTextFieldElement";

export const PasswordFieldElement = <
  FormValues extends FieldValues,
  FieldName extends FieldPath<FormValues>,
>(
  props: Omit<
    BaseTextFieldElementProps<FormValues, FieldName>,
    "getValueFromEvent" | "isValueChangeCancelled" | "type"
  >,
) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <BaseTextFieldElement<FormValues, FieldName>
      {...props}
      getValueFromEvent={(event: ChangeEvent<HTMLInputElement>) =>
        event.target.value as FieldPathValue<FormValues, FieldName>
      }
      rules={{
        required: props.required ? "Heslo je povinné." : false,
      }}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={() => setShowPassword(!showPassword)}
              >
                <Iconify
                  icon={
                    showPassword ? "solar:eye-bold" : "solar:eye-closed-bold"
                  }
                />
              </IconButton>
            </InputAdornment>
          ),
        },
        inputLabel: props.slotProps?.inputLabel,
      }}
      type={showPassword ? "text" : "password"}
    />
  );
};
